import { useEffect } from "react";
import { getSiteConfig } from "@/config/siteConfigs";
import { updateGtagConsent } from "@/utils/updateGtagConsent";

// Завантаження GTM
const loadGTM = () => {
  if (document.getElementById("gtm-script")) return;

  const siteConfig = getSiteConfig();
  const GTM_ID = siteConfig.gtm.containerId;

  if (!siteConfig.gtm.enabled) return;

  // ✅ ВАЖЛИВО: dataLayer ПЕРЕД завантаженням скрипта
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  // Тепер додаємо скрипт
  const script = document.createElement("script");
  script.id = "gtm-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  // Додаємо noscript fallback
  addGTMNoscript(GTM_ID);
};

// Додаємо noscript iframe як вимагає Google
const addGTMNoscript = (GTM_ID: string) => {
  if (document.getElementById("gtm-noscript")) return;

  const noscript = document.createElement("noscript");
  noscript.id = "gtm-noscript";
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

  // Вставляємо на початок body
  document.body.insertBefore(noscript, document.body.firstChild);
};

// 🆕 Завантаження Google Analytics (GA4)
const loadGA4 = () => {
  if (document.getElementById("ga4-script")) return;

  const siteConfig = getSiteConfig();
  const GA4_ID = siteConfig.analytics.measurementId;

  if (!siteConfig.analytics.enabled) return;

  // Ініціалізуємо dataLayer
  window.dataLayer = window.dataLayer || [];

  // Додаємо gtag функцію
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", GA4_ID);

  // Додаємо скрипт GA4
  const script = document.createElement("script");
  script.id = "ga4-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);
};

const GTMConsentHandler = () => {
  useEffect(() => {
    const consentStatus = localStorage.getItem("cookieConsent");
    const savedSettings = localStorage.getItem("cookieSettings");

    if (consentStatus === "accepted") {
      loadGTM();
      loadGA4(); // 🆕 Завантажуємо GA4
      updateGtagConsent({
        necessary: true,
        analytics: true,
        marketing: true,
        preferences: true,
      });
    } else if (consentStatus === "custom" && savedSettings) {
      try {
        const settings = JSON.parse(savedSettings);

        if (settings.analytics) {
          loadGTM();
          loadGA4(); // 🆕 Завантажуємо GA4 тільки якщо аналітика дозволена
        }

        updateGtagConsent(settings);
      } catch (error) {
        console.error("Failed to parse cookie settings:", error);
      }
    } else if (consentStatus === "declined") {
      updateGtagConsent({
        necessary: true,
        analytics: false,
        marketing: false,
        preferences: false,
      });
    }
  }, []);

  return null;
};

export default GTMConsentHandler;
